import React from 'react';
import { Star, ArrowRight, Lock } from 'lucide-react';
import { Badge } from '../components/ui/badge';

export default function ProductCard({ product, onSelect, index = 0 }) {
  return (
    <button
      onClick={() => onSelect(product)}
      style={{ animationDelay: `${index * 70}ms` }}
      className="group glass transition-luxe animate-fade-up w-full text-left rounded-2xl p-3 hover:-translate-y-1 hover:border-[rgba(139,92,246,0.4)] hover:bg-[rgba(255,255,255,0.06)] flex items-center gap-4"
    >
      <div className="relative h-20 w-20 shrink-0 overflow-hidden rounded-xl">
        <img
          src={product.image}
          alt={product.title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
      </div>

      <div className="min-w-0 flex-1">
        <div className="mb-1 flex items-center gap-2">
          <span className="text-[11px] font-medium uppercase tracking-wider text-primary">{product.type}</span>
          {product.badge && (
            <Badge className="h-4 rounded-full border-0 bg-white/10 px-2 text-[10px] font-medium text-white">
              {product.badge}
            </Badge>
          )}
        </div>
        <h3 className="font-display truncate text-[15px] font-600 font-semibold text-white">{product.title}</h3>
        <p className="truncate text-xs text-muted-foreground">{product.subtitle}</p>
        <div className="mt-1.5 flex items-center gap-2">
          <span className="font-display text-lg font-bold text-white">${product.price}</span>
          {product.compareAt && (
            <span className="text-xs text-muted-foreground line-through">${product.compareAt}</span>
          )}
          <span className="ml-auto flex items-center gap-1 text-xs text-muted-foreground">
            <Star className="h-3 w-3 fill-primary text-primary" /> {product.rating}
          </span>
        </div>
      </div>

      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-primary-foreground transition-luxe group-hover:scale-110 glow-lime">
        <ArrowRight className="h-4 w-4" />
      </div>
    </button>
  );
}

export function ProductCardSkeleton() {
  return (
    <div className="glass flex w-full items-center gap-4 rounded-2xl p-3">
      <div className="h-20 w-20 shrink-0 animate-pulse rounded-xl bg-white/5" />
      <div className="flex-1 space-y-2">
        <div className="h-3 w-1/3 animate-pulse rounded bg-white/5" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-white/5" />
        <div className="h-4 w-1/4 animate-pulse rounded bg-white/5" />
      </div>
    </div>
  );
}
